import { memo } from "react";

import AppPaginationDto from "dto/components/app-pagination-dto";

const AppPagination = ({ currentPage, totalPages, onPageChange, numberOfElements }: AppPaginationDto) => {
	const onHandlePreviousPage = () => {
		onPageChange(currentPage - 1);
	};

	const onHandleNextPage = () => {
		onPageChange(currentPage + 1);
	};

	return (
		<div className="app-pagination">
			<div className="pagination">
				<span className="pagination__info">
					{1 + 10 * currentPage}-{numberOfElements ? numberOfElements + 10 * currentPage : 10 + 10 * currentPage} of {totalPages} pages
				</span>

				<div className="pagination__controls">
					<p className="pagination__text">
						The page you're on <span>{currentPage + 1}</span>
					</p>

					<div className="pagination__cta-container">
						<button className="pagination__cta" onClick={onHandlePreviousPage} disabled={currentPage === 0}>
							<span className="pagination__arrow">&lt;</span>
						</button>

						<button className="pagination__cta" onClick={onHandleNextPage} disabled={currentPage + 1 === totalPages}>
							<span className="pagination__arrow">&gt;</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default memo(AppPagination);
